import { Grid } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import constant from "@/utils/constant";
import { Input, Typography } from "@dippi/ui";
import { Styled } from "../../styles";
import Calendar from "./widgets/calendar";

const Base: React.FC = () => {
    const {
        control,
        formState: { defaultValues },
    } = useFormContext();

    const endDate = defaultValues?.endDate && defaultValues.endDate;
    const isActive = endDate
        ? new Date(endDate).setHours(23, 59, 59, 999) >= new Date().getTime()
        : true;

    return (
        <Styled.Container container item xs={12} gap={constant.GRID_SPACING}>
            <Grid item xs={12} display="flex" alignItems="center" gap={constant.GRID_SPACING / 2}>
                <Typography variant="h3" marginBottom="unset">
                    Campaign Information
                </Typography>
                <Styled.Badge isActive={isActive}>
                    <Typography
                        variant="subtitle2"
                        color={isActive ? "success.main" : "error.main"}
                        fontWeight={500}
                        fontSize="0.85rem"
                    >
                        {isActive ? "Active" : "Inactive"}
                    </Typography>
                </Styled.Badge>
            </Grid>
            <Grid container item xs={12} spacing={constant.GRID_SPACING}>
                <Grid item lg={3.5} md={5} xs={12}>
                    <Input name="name" control={control} label="Name" />
                </Grid>
                <Grid item lg={1.5} md={2} xs={6}>
                    <Input
                        name="code"
                        control={control}
                        label="Code"
                        placeholder="e.g. ABC1"
                    />
                </Grid>
            </Grid>
            <Grid container item xs={12} spacing={constant.GRID_SPACING}>
                <Grid item lg={3.5} md={5} xs={12}>
                    <Calendar />
                </Grid>
            </Grid>
        </Styled.Container>
    );
};

export default Base;
